import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Intro from '../views/Intro.vue';
import Market from '../views/Market.vue';
import Tech from '../views/Tech.vue';
import Token from '../views/Token.vue';
import Ecosystem from '../views/Ecosystem.vue';
import Static from '../views/Static.vue';
import Dynamic from '../views/Dynamic.vue';
import Roadmap from '../views/Roadmap.vue';
import Department from '../views/Department.vue';
import Template from '../views/Template.vue';
import Signing from '../views/Signing.vue';
import Contact from '../views/Contact.vue';
import Recruitment from '../views/Recruitment.vue';
import templateInfo from '../views/templateInfo.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/intro',
    name: 'Intro',
    component: Intro,
  },
  {
    path: '/market',
    name: 'Market',
    component: Market,
  },
  {
    path: '/tech',
    name: 'Tech',
    component: Tech,
  },
  {
    path: '/token',
    name: 'Token',
    component: Token,
  },
  {
    path: '/ecosystem',
    name: 'Ecosystem',
    component: Ecosystem,
  },
  {
    path: '/static',
    name: 'Static',
    component: Static,
  },
  {
    path: '/dynamic',
    name: 'Dynamic',
    component: Dynamic,
  },
  {
    path: '/roadmap',
    name: 'Roadmap',
    component: Roadmap,
  },
  {
    path: '/templateInfo',
    name: 'templateInfo',
    component: templateInfo,
  },
  {
    path: '/department',
    name: 'Department',
    component: Department,
  },
  {
    path: '/template',
    name: 'Template',
    component: Template,
  },
  {
    path: '/signing',
    name: 'Signing',
    component: Signing,
  },
  {
    path: '/contact',
    name: 'Contact',
    component: Contact,
  },
  {
    path: '/recruitment',
    name: 'Recruitment',
    component: Recruitment,
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});


const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}


export default router;